import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Input, Label, Textarea } from "rbx";

import { ProductSelect, SystemCodeSelect } from "../inputs";

const RouteProductBillingForm = ({ adding, inputs, onChange }) => (
  <div style={{ width: 800, maxWidth: "100%" }}>
    <Field kind="group">
      <Control expanded>
        <ProductSelect
          icon="globe"
          label="Product"
          name="ProductNoRecIdRef"
          value={inputs.ProductNoRecIdRef}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Hazmat Code</Label>
        <Input
          disabled
          required
          autocomplete="new"
          name="HazmatCode"
          value={inputs.HazmatCode}
          onChange={onChange}
        />
      </Control>
    </Field>

    <Field kind="group">
      <Control expanded>
        <SystemCodeSelect
          icon="globe"
          label="UOM"
          lookup={{ Code: "UOM" }}
          name="UOMRecIdRef"
          showHelp={!adding}
          value={inputs.UOMRecIdRef}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Rate</Label>
        <Input
          name="Rate"
          type="number"
          value={inputs.Rate}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Percentage</Label>
        <Input
          name="Percentage"
          type="number"
          value={inputs.Percentage}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Description</Label>
        <Input
          name="Description"
          type="text"
          value={inputs.Description}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field kind="group">
      <Control expanded>
        <Label>External Comment</Label>
        <Textarea
          name="ExternalComm"
          rows="2"
          value={inputs.ExternalComm}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Internal Comment</Label>
        <Textarea
          name="InternalComm"
          rows="2"
          value={inputs.InternalComm}
          onChange={onChange}
        />
      </Control>
    </Field>
  </div>
);
RouteProductBillingForm.propTypes = {
  adding: PropTypes.bool,
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

RouteProductBillingForm.defaultProps = {
  adding: false
};

export default RouteProductBillingForm;
